"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("../index.scss");
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const Sidebar_1 = require("@Components/Sidebars/Sidebar");
const AddWriter_1 = __importDefault(require("@Components/WorkRegistrationSubs/AddWriter"));
const EditSimpleWriter_1 = __importDefault(require("@Components/WorkRegistrationSubs/EditSimpleWriter"));
const removers_1 = require("@App/helpers/work-entities/removers");
const contexts_1 = require("@App/contexts");
const CellDropdown_1 = __importDefault(require("@Components/ViewWork/Table/ValidationCells/CellDropdown"));
const CellInput_1 = __importDefault(require("@Components/ViewWork/Table/ValidationCells/CellInput"));
const writers_table_schema_1 = require("@Entities/schemas/wizardFlow/writers-table-schema");
const TablesForm_1 = __importDefault(require("@Components/ViewWork/Table/TablesForm"));
const WizardStepHeading_1 = __importDefault(require("@Components/WizardFlow/WizardStepHeading"));
const format_name_1 = require("@App/helpers/format-name");
const react_router_dom_1 = require("react-router-dom");
const WritersStep = () => {
    const { workStore, popupStore, libStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [popupType, setPopupType] = (0, react_1.useState)();
    const [sidebarIsOpen, setSidebarIsOpen] = (0, react_1.useState)(false);
    const [editingWriter] = (0, react_1.useState)();
    const removeWriter = (removingWriter) => {
        try {
            const workDraftFromLocal = workStore.workDraftLocal;
            if (!workDraftFromLocal) {
                return;
            }
            const updatedWorkDraft = (0, removers_1.writerRemover)(removingWriter, workDraftFromLocal);
            workStore.setWorkDraftToLocal(updatedWorkDraft);
        }
        catch (e) {
            popupStore.setAlertFromError(e);
        }
    };
    const openSidebar = (typePopup) => {
        setPopupType(typePopup);
        setSidebarIsOpen(true);
    };
    const closeSidebar = () => {
        setSidebarIsOpen(false);
    };
    const stepValidator = (isValid) => {
        const workDraftFromLocal = workStore.workDraftLocal;
        if (!workDraftFromLocal) {
            return;
        }
        workStore.setWizardStepValidation(isValid);
    };
    const roleOptions = libStore.writerRoles;
    const getRole = (roleCode) => {
        if (!roleCode) {
            return '';
        }
        const writerRole = roleOptions.find((role) => +role.id === roleCode);
        if (writerRole && writerRole.label) {
            return writerRole.label;
        }
        return '';
    };
    (0, react_1.useEffect)(() => {
        stepValidator(true);
    }, []);
    const workDraftFromLocal = workStore.workDraftLocal;
    if (!workDraftFromLocal) {
        return null;
    }
    const headerRow = {
        row: [{ text: 'Writer Name' }, { text: 'Writer IPI' }, { text: 'Writer Role' }],
        removableCells: true,
    };
    const writerTableInfo = (0, react_1.useMemo)(() => {
        const rows = workDraftFromLocal === null || workDraftFromLocal === void 0 ? void 0 : workDraftFromLocal.writers.map((writerModel, index) => {
            var _a, _b;
            return ({
                removeCellIdentifier: (_a = writerModel.ipId) !== null && _a !== void 0 ? _a : '',
                removable: true,
                cells: [
                    react_1.default.createElement(CellInput_1.default, { defaultValue: (0, format_name_1.formatName)(writerModel.firstName, writerModel.lastName), readOnly: true, name: `rows[${index}].writerName`, key: `${writerModel.ipId}.writerName`, type: 'text' }),
                    react_1.default.createElement(CellInput_1.default, { name: `rows[${index}].writerIPI`, key: `${writerModel.ipId}.writerIPI`, defaultValue: (_b = writerModel.ipiNumber) !== null && _b !== void 0 ? _b : '', readOnly: true, type: 'text' }),
                    react_1.default.createElement(CellDropdown_1.default, { name: `rows[${index}].writerRole`, key: `${writerModel.ipId}.writerRole`, value: getRole(writerModel.roleCode), onSelectedValueChanged: (newValue) => {
                            updateRole(index, writerModel, newValue);
                        } }),
                ],
            });
        });
        return [
            {
                headerRow: headerRow,
                rows: rows,
            },
        ];
    }, [workDraftFromLocal, workDraftFromLocal.writers]);
    const updateRole = (index, writerModel, newValue) => {
        const updatedWriterModel = Object.assign(Object.assign({}, writerModel), { roleCode: Number.parseInt(newValue.id, 10) });
        const updatedWritersArray = (0, removers_1.setItemToArrayByIndex)(workDraftFromLocal.writers, index, updatedWriterModel);
        const updatedOP = workDraftFromLocal.originalPublishers.map((op) => {
            const updatedWr = op.writers.map((writer) => {
                if (writer.localId === updatedWriterModel.localId) {
                    return Object.assign(Object.assign({}, writer), { roleCode: updatedWriterModel.roleCode });
                }
                else {
                    return writer;
                }
            });
            return Object.assign(Object.assign({}, op), { writers: updatedWr });
        });
        const updatedWorkDraft = Object.assign(Object.assign({}, workDraftFromLocal), { writers: updatedWritersArray, originalPublishers: updatedOP });
        workStore.setWorkDraftToLocal(updatedWorkDraft);
    };
    return (react_1.default.createElement("div", { className: 'writers-step' },
        react_1.default.createElement("div", { className: "step-content" },
            react_1.default.createElement(WizardStepHeading_1.default, { heading: 'Add Writers & Roles', title: workDraftFromLocal.title },
                react_1.default.createElement("p", null,
                    "Enter all writer(s) and their roles. A full list of writer roles and their definitions can be found in our Help Center article",
                    ' ',
                    react_1.default.createElement(react_router_dom_1.Link, { className: 'tooltip', to: 'https://help.themlc.com/en/support/writer-roles', target: "_blank", rel: "noopener noreferrer" }, "here.")),
                react_1.default.createElement("p", null, "Please note: At least one Composer/Author or Composer writer role is required for all new registrations.")),
            react_1.default.createElement(TablesForm_1.default, { headingDecoration: {
                    icon: 'writers',
                    title: 'Writers',
                    required: true,
                }, tableInfos: writerTableInfo, addButtonTitle: 'Add Writer', onAddButtonClicked: () => {
                    openSidebar('addWriter');
                }, onRemoveCellClicked: (index, removeCellIdentifier, reset, values) => {
                    removeWriter(workDraftFromLocal === null || workDraftFromLocal === void 0 ? void 0 : workDraftFromLocal.writers[index]);
                    if (values && reset) {
                        values === null || values === void 0 ? void 0 : values.rows.splice(index, 1);
                        reset(Object.assign({}, values));
                    }
                }, validationSchema: (0, writers_table_schema_1.writersTableSchema)(workDraftFromLocal.isComplete), rowsAreValid: stepValidator })),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: sidebarIsOpen, onClose: closeSidebar },
            react_1.default.createElement(Sidebar_1.Sidebar, { onClose: closeSidebar },
                popupType === 'addWriter' ? react_1.default.createElement(AddWriter_1.default, { closePopupFunc: closeSidebar }) : null,
                popupType === 'editWriter' && editingWriter ? (react_1.default.createElement(EditSimpleWriter_1.default, { editingWriter: editingWriter, closePopupFunc: closeSidebar })) : null))));
};
exports.default = (0, mobx_react_1.observer)(WritersStep);
